import {useTranslation} from 'react-i18next';
import * as css from './PlanRow.css';
import {SubscriptionPlan} from '../../../../../../../redux/subscription/subscription.type';
import {seriesTypeLabel} from '../../../../../../subscriptions/utils/subscriptionUtils';
import PlanImage from '../../../../../../subscriptions/components/planImage/PlanImage';
import {defaultImage} from '../../../../../../../assets/symbols/images/defaultImage';
import {calculatePercentage} from '../../../../../../subscriptions/utils/planCalculations';
import {Button} from '@tickchak/react-share/app';

interface PlanRowProps {
    plan: SubscriptionPlan;
    onOpenDetails: (plan: SubscriptionPlan) => void;
}

function PlanRow({plan, onOpenDetails}: PlanRowProps) {
    const {t} = useTranslation('realtime');
    const statusKey = plan.planType;
    const bgColor = seriesTypeLabel[statusKey]?.color;
    const statusText = t(seriesTypeLabel[plan.planType]?.label);

    return (
        <css.row>
            <css.nameSection>
                <PlanImage
                    image={plan.image?.path || defaultImage}
                    realizationPercentage={calculatePercentage(plan)}
                    variant="row"
                    color={plan.color}
                />
                <css.infoWrapper>
                    <css.statusBadge className='free-color' $bgColor={bgColor}>
                        {statusText}
                    </css.statusBadge>
                    <css.seriesName>{plan.title}</css.seriesName>
                </css.infoWrapper>
            </css.nameSection>
            <css.moreInfoButton>
                <Button onClick={() => onOpenDetails(plan)} variant="subtle" size="chip" customStyle={{backgroundColor: 'var(--primitive-black-05)'}}>{t('moreInfo')}</Button>
            </css.moreInfoButton>
            <css.cell>
                <css.mobileLabel>{t('eventsInSeries')}</css.mobileLabel>
                {plan.eventsCount || 0}
            </css.cell>
            <css.cell>
                <css.mobileLabel>{t('activeEvents')}</css.mobileLabel>
                {plan.activeEventsCount || 0}
            </css.cell>
            <css.cell>
                <css.mobileLabel>{t('pastEvents')}</css.mobileLabel>
                {plan.passedEventsCount || 0}
            </css.cell>
            <css.cell>
                <css.mobileLabel>{t('salesPerPlan')}</css.mobileLabel>
                {plan.amount - plan.amountAvailable || 0}
            </css.cell>
            <css.cell>
                <css.mobileLabel>{t('remainingTickets')}</css.mobileLabel>
                {plan.amountAvailable || 0}
            </css.cell>
            <css.cell>
                <css.mobileLabel>{t('realizations')}</css.mobileLabel>
                {plan.realizations || 0}
            </css.cell>
        </css.row>
    );
}

export default PlanRow;
